import { getChartDevice } from '@/api/device-chart'
import { createRequestCancellation, isRequestCanceled } from '@/api/http'
import { responseBody, chartProperties, numericProperty } from '@/runtime/device-chart-data'

// 旧组件物模型属于属性检查器，不属于画布拖动/失焦事件；新文本和图表沿用原专用加载器。
export default {
  computed: {
    legacyDeviceSettingsKey () {
      return !this.isComponentTemplateEditing && !this.activeHasDeviceBinding && Number(this.activeObj.dataType) === 2 && this.activeParameter.deviceId
        ? JSON.stringify([this.activeObj.index, this.activeParameter.deviceId]) : ''
    }
  },
  watch: { legacyDeviceSettingsKey: { immediate: true, handler: 'loadLegacyDeviceSettings' } },
  beforeDestroy () { if (this._legacyDeviceCancel) this._legacyDeviceCancel.cancel() },
  methods: {
    async loadLegacyDeviceSettings () {
      if (this._legacyDeviceCancel) this._legacyDeviceCancel.cancel()
      const key = this.legacyDeviceSettingsKey
      this.propertyList = []; this.otherPropertyList = []; this.functionList = []
      if (!key) return
      const cancellation = createRequestCancellation()
      this._legacyDeviceCancel = cancellation
      try {
        const body = responseBody(await getChartDevice(this.activeParameter.deviceId, { cancelToken: cancellation.token }))
        if (this._isDestroyed || key !== this.legacyDeviceSettingsKey || this._legacyDeviceCancel !== cancellation) return
        const metadata = body.result && body.result.metadata
        const model = typeof metadata === 'string' ? JSON.parse(metadata) : metadata
        if (!model || !Array.isArray(model.properties)) throw new Error('设备物模型格式不正确')
        const numeric = new Set(chartProperties(model).filter(numericProperty).map(property => property.id))
        this.propertyList = model.properties.filter(property => numeric.has(property.id))
        this.otherPropertyList = model.properties
        this.functionList = Array.isArray(model.functions) ? model.functions : []
      } catch (error) {
        if (!this._isDestroyed && key === this.legacyDeviceSettingsKey && this._legacyDeviceCancel === cancellation && !isRequestCanceled(error)) this.$message.error(error.message || '设备物模型读取失败')
      }
    }
  }
}
